import { render, staticRenderFns } from "./LayerBubble.vue?vue&type=template&id=23a5bd9d&"
import script from "./LayerBubble.vue?vue&type=script&lang=js&"
export * from "./LayerBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports